import React from "react"

import PackageSections from "~components/pages/listing/pricing/package-sections"
import { useCheckoutFlow } from "~components/pages/listing/checkout/checkout-flow/checkout-flow-provider"
import type {
    BookingInvitePackageInfo,
    PackageState,
} from "~components/pages/listing/checkout/checkout-flow/checkout-flow-types"
import type { PricingPackageFieldsFragment } from "~graphql/generated/graphql"

import { getInitialNumberOfGuests } from "./checkout-flow-helpers"

export default function CheckoutFlowPackageSections({
    dates,
}: {
    readonly dates?: number[]
}) {
    const {
        listing,
        bookingInvitePackageInfo,
        packageState,
        updatePackageState,
    } = useCheckoutFlow()

    return (
        <PackageSections
            hasNextAvailableDate={!listing?.is_unavailable}
            defaultSelectedPackageId={packageState.pricing_package_id}
            listingId={listing?.id}
            published={listing?.published ?? false}
            dates={dates}
            numberOfGuests={packageState.number_of_guests}
            hideContinueButton
            onSelectPackage={(newPricingPackage) =>
                onSelectPackage({
                    newPricingPackage,
                    bookingInvitePackageInfo,
                    updatePackageState,
                })
            }
        />
    )
}

function onSelectPackage({
    newPricingPackage,
    bookingInvitePackageInfo,
    updatePackageState,
}: {
    newPricingPackage: PricingPackageFieldsFragment
    bookingInvitePackageInfo?: BookingInvitePackageInfo | null
    updatePackageState: (update: Partial<PackageState>) => void
}) {
    // Set the initial number of guests for new package as well.
    // The new package may have different min/max or fixed/per settings.
    const initialNumberOfGuests = getInitialNumberOfGuests({
        pricingPackage: newPricingPackage,
        bookingInvitePackageInfo,
    })

    updatePackageState({
        pricing_package_id: newPricingPackage.id,
        number_of_guests: initialNumberOfGuests,
    })
}
